import React from 'react';
import PublicRoutes from './PublicRoutes';
import AuthorizedRoutes from './AuthorizedRoutes';
import useAuth from '../hooks/useAuth';
import { NavigationLogger } from '../components/NavigationLogger';

function Routes() {
    const { isUserAuthenticated } = useAuth();
    return (
        <>
            <NavigationLogger />
            {isUserAuthenticated
                ? (
                    <AuthorizedRoutes />
                )
                : (
                    <PublicRoutes />
                )}
        </>
    );
}

export default Routes;
